export default {
  General: {
    Email: "Correo electrónico",
    Send: "Enviar",
    Done: "Listo",
    Finish: "Acabar",
    Try_again: "Volver a intentar",
    or: "o"
  },
  SamsungType: {
    bixby: "Con Bixby",
    no_bixby: "Sin Bixby",
    home_button: "Con el botón de inicio"
  },
  sendEmail: {
    repair_tip1: "Este modelo no se puede reparar con la aplicación móvil. Te enviaremos la solución de escritorio por correo electrónico.",
    check_tip1: "La comprobación del dispositivo no se puede completar solo con la aplicación móvil. Le enviaremos la solución de escritorio por correo electrónico.",
    tip1: "Este modelo no se puede desbloquear con la aplicación móvil. Te enviaremos la solución de escritorio por correo electrónico.",
    tip2: "Conecta el teléfono al ordenador mediante un cable de datos para que funcione mejor.",
    enter_address: "Introduce tu dirección de correo electrónico.",
    enter_correct_address: "Por favor, introduzca la dirección de correo electrónico correcta.",
    confidential: "Tu dirección de correo electrónico será estrictamente confidencial.",
    open_link: "Abre {0} en el navegador de tu ordenador para descargar Dr.Fone.",
    has_sent: "Se ha enviado tu correo electrónico",
    almost: "Ya casi hemos terminado",
    step1: "Paso 1",
    open_email: "Abre el correo electrónico en tu ordenador y utiliza el enlace que te hemos enviado para descargar la versión de escritorio de Dr.Fone.",
    step2: "Paso 2",
    repair_launch_tip: "Inicie Dr.Fone System Repair e inicie sesión en su cuenta para utilizar la función de reparación.",
    check_launch_tip: "Instale la versión de escritorio de Dr.Fone e inicie sesión con la misma cuenta. Haga clic en \"My Device\" y siga las instrucciones en pantalla para conectar su dispositivo. Una vez conectado, haga clic en \"Device Detail\" para ver los resultados detallados de la comprobación.",
    launch_tip: "Abre Desbloquear en Dr.Fone e inicia sesión en tu cuenta para utilizar la función de desbloqueo.",
    contact_us: "Ponte en contacto con nosotros para obtener ayuda."
  },
  Unlock: {
    recoveryMode: "Pon el dispositivo en modo de recuperación",
    wipe_cache: "Borra la partición de caché del dispositivo",
    wipe_data: "Sigue las instrucciones para borrar los datos del dispositivo",
    completed: "Desbloqueo completado",
    completed_tip: "Comprueba si el dispositivo ha eliminado correctamente el bloqueo de pantalla. Si no es así, vuelve a intentarlo.",
    contact_us: "¿Ha fallado el desbloqueo? Ponte en contacto con nosotros para obtener ayuda."
  },
  UnlockStep: {
    sa1: "1. Apaga el teléfono y mantenlo desconectado del ordenador ",
    sa2: "2. Mantén pulsados los botones «Subir volumen», «Bixby» y «Encender» al mismo tiempo",
    sa3: "3. Suelta los botones cuando aparezca el logotipo de Samsung y espera unos segundos",
    sa4: "4. Ahora, el dispositivo debería iniciarse en modo de recuperación. Selecciona «Reiniciar el gestor de arranque» para acceder al modo de descarga",
    sb1: "1. Apaga el teléfono y mantenlo conectado del ordenador",
    sb2: "2. Mantén presionados los botones de «Encendido» y «Subir Volumen» al mismo tiempo",
    sb3: "3. Mantén pulsados los dos botones incluso después de que el dispositivo se reinicie",
    sb4: "4. Ahora, el dispositivo debería iniciarse en modo de recuperación. Selecciona «Reiniciar el gestor de arranque» para acceder al modo de descarga",
    sc1: "1. Apaga el teléfono y mantenlo conectado del ordenador",
    sc2: "2. Mantén pulsados los botones «Subir volumen», «Inicio» y «Encender» al mismo tiempo",
    sc3: "3. Suelta los botones cuando aparezca el logotipo de Samsung y espera unos segundos",
    sc4: "4. Ahora, el dispositivo debería iniciarse en modo de recuperación. Selecciona «Reiniciar el gestor de arranque» para acceder al modo de descarga",
    s5: "5. Pulsa el botón de volumen para seleccionar «Borrar datos/restablecimiento de fábrica» y, a continuación, pulsa el botón de encendido para confirmar",
    s6: "6. Pulsa el botón de volumen para seleccionar «Sí» y, a continuación, pulsa el botón de encendido para confirmar",
    s7: "7. Pulsa «Borrar partición de caché» y, a continuación, selecciona «Sí»",
    s8: "8. Selecciona «Reiniciar sistema ahora» y pulsa el botón de encendido para confirmar. El dispositivo tardará algún tiempo en reiniciarse.",
    common1: "Apaga tu teléfono.",
    common2: "Pulsa el botón de encendido y el de subir volumen durante unos segundos.",
    common3: "Suelta todos los botones cuando aparezca Modo de recuperación en la pantalla.",
    m4: "Selecciona «Borrar datos» con los botones de volumen y usa el de encendido para aceptar.",
    m5: "Selecciona «Borrar todos los datos».",
    m6: "Después, selecciona «Confirmar» y espera a que finalice el proceso.",
    m7: "Vuelve al menú principal con el botón de encendido.",
    m8: "Selecciona «Reiniciar».",
    m9: "Por último, selecciona «Reiniciar el sistema».",
    h4: "Selecciona «Borrar datos» con los botones de volumen y usa el de encendido para aceptar.",
    h5: "Selecciona «Restablecimiento de fábrica».",
    h6: "Escribe la palabra «sí» y, a continuación, selecciona «Restablecimiento de fábrica».",
    h7: "Durante esta operación, se eliminarán todos los archivos.",
    h8: "Selecciona «Atrás» para volver al menú principal.",
    h9: "Por último, selecciona «Reiniciar»."
  }
};
